import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: "25%",
              text: "",
            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [
                "UTILIDAD VENTA PRODUCTO\n",
                "AGRUPADO CATEGORIA\n",
                "Del " + mainData.FI + " a " + mainData.FF + "\n",
              ],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: "*",
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let times = [
      [
        {
          text: "Nombre",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        },
        { text: "Cantidad", border: [true, true, true, true], fontSize: 12 },
        { text: "Precio", border: [true, true, true, true], fontSize: 12 },
        { text: "Coste", border: [true, true, true, true], fontSize: 12 },
        {
          text: "Total Venta",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "right",
        },
        {
          text: "Coste Total",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "right",
        },
        {
          text: "Beneficio",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "right",
        },
      ],
    ];
    let grandTotal = 0;
    let grandTotalCoste = 0;
    let grandTotalBeneficio = 0;
    let groupedData = [];
    let total = 0;
    let totalCoste = 0;
    let totalBeneficio = 0;
    let totalCantidad = 0;
    let totalTurista = 0;
    let totalLocales = 0;
    let paxTuristas = 0;
    let paxLocales = 0;
    let orderedData = _.orderBy(
      data,
      ["CategoriaName", "Vendidos"],
      ["desc", "desc"]
    );

    let grouper = "";
    orderedData.forEach((venta, index) => {
      if (grouper != venta.CategoriaName) {
        groupedData.push({
          header: true,
          text: venta.CategoriaName,
        });
      }
      groupedData.push(venta);
      if (venta.CategoriaName == "GREEN FEE") {
        if (venta.Tur) {
          totalTurista += Number(venta.Total);
          paxTuristas += Number(venta.Vendidos);
        } else {
          totalLocales += Number(venta.Total);
          paxLocales += Number(venta.Vendidos);
        }
      }
      total += Number(venta.Total);
      totalCoste += Number(venta.TotalCoste)
      totalCantidad += Number(venta.Vendidos);
      totalBeneficio += Number(venta.Beneficio)
      grouper = venta.CategoriaName;

      if (orderedData[index + 1]) {
        if (orderedData[index + 1].CategoriaName != venta.CategoriaName) {
          if (venta.CategoriaName == "GREEN FEE") {
            groupedData.push({
              greenFeeSumatory: true,
            });
          }
          groupedData.push({
            footer: true,
            text: "Total",
            total: total,
            totalCantidad: totalCantidad,
            totalCoste:totalCoste,
            totalBeneficio:totalBeneficio
          });
          total = 0;
          totalCoste = 0;
          totalCantidad = 0;
          totalBeneficio = 0;
        }
      } else {
        if (venta.CategoriaName == "GREEN FEE") {
          groupedData.push({
            greenFeeSumatory: true,
          });
        }
        groupedData.push({
          footer: true,
          text: "Total",
          total: total,
          totalCantidad: totalCantidad,
          totalCoste:totalCoste,
          totalBeneficio:totalBeneficio
        });
        total = 0;
          totalCoste = 0;
          totalCantidad = 0;
          totalBeneficio = 0;
      }
    });
    
    groupedData.forEach((venta) => {
      let rowToAdd = [];
      if (!venta.header & !venta.footer && !venta.greenFeeSumatory) {
        rowToAdd = [
          {
            text: venta.Nombre,
            border: [true, false, false, false],
            fontSize: 10,
            alignment: "left",
          },
          {
            text: venta.Vendidos,
            border: [false, false, false, false],
            fontSize: 9,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Precio),
            border: [false, false, false, false],
            fontSize: 9,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Coste),
            border: [false, false, false, false],
            fontSize: 9,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            border: [false, false,false, false],
            fontSize: 10,
          },{
            text: "$" + pgsHelper.formatNumber(venta.TotalCoste),
            border: [false, false, false, false],
            fontSize: 9,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Beneficio),
            border: [false, false,true, false],
            fontSize: 9,
            alignment: "right",
          },
        ];
        times.push(rowToAdd);
      }
      if (venta.header) {
        rowToAdd = [
          {
            text: venta.text,
            border: [true, true, true, true],
            fontSize: 12,
            colSpan: 7,
            fillColor: "#CCE3F4",
          },
        ];
        times.push(rowToAdd);
      }
      if (venta.footer) {
        
        grandTotal += Number(venta.total);
        grandTotalCoste += Number(venta.totalCoste)
        grandTotalBeneficio += Number(venta.totalBeneficio)
        rowToAdd = [
          {
            text: venta.text,
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text:"$" + pgsHelper.formatNumber(venta.totalCantidad) ,
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: "",
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: "",
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.total),
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.totalCoste),
            border: [true, true, true, true],
            fontSize: 10,
            fillColor: "#DCDCDC",
            alignment: "left",
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.totalBeneficio),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
            fillColor: "#DCDCDC",
          },
        ];
        times.push(rowToAdd);
      }
      if (venta.greenFeeSumatory) {
        console.log("suma")
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      table: {
        body: times,
      },
    };

    times.push([
      {
        text: "TOTAL GENERAL",
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "$" + pgsHelper.formatNumber(grandTotal),
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "$" + pgsHelper.formatNumber(grandTotalCoste),
        border: [true, true, true, true],
        fontSize: 10,
        fillColor: "#DCDCDC",
        alignment: "left",
      },
      {
        text: "$" + pgsHelper.formatNumber(grandTotalBeneficio),
        bold: true,
        border: [true, true, true, true],
        fontSize: 10,
        alignment: "right",
        fillColor: "#DCDCDC",
      },
    ]);

    return times;
  }

  static getFirmas(data, porcentaje) {
    let times = [
      [
        { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        {
          text: "%" + porcentaje,
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Firma", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((venta) => {
      let rowToAdd = [];
      if (venta.tipo == "footer") {
        rowToAdd = [
          {
            text: venta.Mesero,
            border: [true, true, true, true],
            fontSize: 10,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text:
              "$" +
              pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text: " ",
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      heights: 60,
      table: {
        body: times,
      },
    };

    return times;
  }
}
